import { formatDate } from "../../../../shared/utils/audbilityFormatters";
import { renderExpiration, renderScreeningStatus } from "../columns";

export const PATIENT_SCREENINGS_COLUMNS = [
  {
    title: "Triagem",
    dataIndex: "number",
    key: "number",
    render: (number) => <strong>{number}</strong>,
  },
  { title: "Etapa", dataIndex: "stage", key: "stage" },
  {
    title: "Inicio",
    dataIndex: "startedAt",
    key: "startedAt",
    render: (startedAt) => formatDate(startedAt),
  },
  {
    title: "Vencimento",
    dataIndex: "expiration",
    key: "expiration",
    render: renderExpiration,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: renderScreeningStatus,
  },
];
